import { render, staticRenderFns } from "./adInfoUpdate.vue?vue&type=template&id=22ca896f&scoped=true"
import script from "./adInfoUpdate.vue?vue&type=script&lang=js"
export * from "./adInfoUpdate.vue?vue&type=script&lang=js"
import style0 from "./adInfoUpdate.vue?vue&type=style&index=0&id=22ca896f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca896f",
  null
  
)

export default component.exports